import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import endpoint from 'utils/backend/endpoint.util';
import fromAnyToCoin from 'utils/converters/any/fromAnyToCoinNum.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import actionBe from 'utils/mw/actionBe.util';

const beRefundPayment = actionBe('beRefundPayment', ({ AT, ATAG, paymentIntentId, refundAmount, isDeposit }) =>
  endpoint(H.post, 'payments/stripe/refund/intent/:salonId/:paymentIntentId/', {
    AT,
    name: ATAG,
    params: { paymentIntentId },
    data: {
      refund_amount: fromAnyToCoin(refundAmount),
      is_deposit: fromAnyToBool(isDeposit),
    },
    umsg: UMSG_TYPE.global,
  }),
);

// noinspection JSUnusedGlobalSymbols
export default beRefundPayment;
